import $ from 'jquery';
import '../libs/jquery.drilldown';

export default class MobileNav {
    constructor() {
        const $drilldown = $('.js-mobile-nav');

        if (!$drilldown.length) return;

        $drilldown.drilldown({
            selector: '.dd-back button, .dd-toggle',
            cssClass: {
                container: 'dd-container',
                root: 'dd-root',
                sub: 'dd-sub',
                back: 'dd-back',
            },
            speed: 200,
        });

        // jquery-drilldown is purely visual, so mirror the open/closed state to
        // assistive tech ourselves. Only two levels, so "back" collapses all.
        const collapseAll = () => $drilldown.find('.dd-toggle').attr('aria-expanded', 'false');

        $drilldown.on('click', '.dd-toggle', (e) => $(e.currentTarget).attr('aria-expanded', 'true'));
        $drilldown.on('click', '.dd-back button', collapseAll);

        $('#mobile-nav').on('closed.zf.offCanvas', () => {
            $drilldown.drilldown('reset');
            collapseAll();
        });
    }
}
